import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./TransportTypesPage.css";

// صور المواد
import FurnitureImage from "../../assets/images/sofa.jpg";
import MovingImage from "../../assets/images/paket.jpg";
import VehicleImage from "../../assets/images/vehicleTransport.jpg";
import PalettenImage from "../../assets/images/pallet.jpg";

// أيقونات
import {
  FaCouch,
  FaTruckMoving,
  FaCarSide,
  FaPallet,
  FaArrowRight,
  FaCarAlt,
} from "react-icons/fa";
import { IoHome } from "react-icons/io5";
import { MdPallet } from "react-icons/md";

export default function TransportTypesPage() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const cards = [
    {
      id: "furniture",
      img: FurnitureImage,
      icon: <FaCouch />,
      title: t("transportTypes.cards.furniture.title", "Möbeltransport"),
      text: t(
        "transportTypes.cards.furniture.text",
        "Wir transportieren Ihre Möbel sicher und zuverlässig an jedes Ziel in Deutschland."
      ),
      link: "/moebeltransport",
    },
    {
      id: "moving",
      img: MovingImage,
      icon: <IoHome />,
      title: t("transportTypes.cards.moving.title", "Umzug"),
      text: t(
        "transportTypes.cards.moving.text",
        "Vergleichen Sie Umzugsfirmen und erhalten Sie die besten Angebote für Ihren Umzug."
      ),
      link: "/umzug",
    },
    {
      id: "vehicle",
      img: VehicleImage,
      icon: <FaCarAlt />,
      title: t("transportTypes.cards.vehicle.title", "Fahrzeugtransport"),
      text: t(
        "transportTypes.cards.vehicle.text",
        "Auto, Motorrad oder Nutzfahrzeug sicher und schnell an jedes Ziel transportieren lassen."
      ),
      link: "/fahrzeugtransport",
    },
    {
      id: "pallet",
      img: PalettenImage,
      icon: <MdPallet />,
      title: t("transportTypes.cards.pallet.title", "Palettentransport"),
      text: t(
        "transportTypes.cards.pallet.text",
        "Palettenversand für Gewerbe und Privat – deutschlandweit und international."
      ),
      link: "/palettentransport",
    },
  ];

  return (
    <>
      <section className="transport-types-page">
        <Container>
          {/* Header */}
          <div className="page-header" data-aos="fade-up">
            <h1 className="page-title">
              {t("transportTypes.page.title", "Beliebte Transportarten")}
            </h1>
            <p className="page-subtitle">
              {t(
                "transportTypes.page.subtitle",
                "Wählen Sie die passende Transportart für Ihre Sendung"
              )}
            </p>
          </div>

          {/* Cards Grid */}
          <Row className="cards-grid g-4" data-aos="fade-up" data-aos-delay="100">
            {cards.map((card) => (
              <Col xs={12} sm={6} lg={3} key={card.id}>
                <div className="transport-card">
                  <div className="card-image-wrapper">
                    <img src={card.img} alt={card.title} className="card-image" />
                    <div className="card-icon-overlay">
                      <div className="card-icon">{card.icon}</div>
                    </div>
                  </div>

                  <div className="card-content">
                    <h3 className="card-title">{card.title}</h3>
                    <p className="card-text">{card.text}</p>
                  </div>
                    <Link to={card.link} className="card-link">
                      {t("transportTypes.button", "Mehr erfahren")}
                      <FaArrowRight className="link-arrow" />
                    </Link>
                  
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
}